module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/cms-panel.35180de3.svg";